<template>
	<div class="put">
		<vs-row class="m-4 p-d">
			<!-- 新增 -->
			<div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="addrule">
			    <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
			    <span class="ml-2 text-base text-primary">添加规则</span>
			</div>
		</vs-row>
		<vs-table ref="table"    :max-items="10"  :data="putlist">
		  <template slot="thead">
		    <vs-th >序号</vs-th>
			<vs-th >部门</vs-th>
			<vs-th >创建时间</vs-th>
			<vs-th >类型</vs-th>
			<vs-th >处理数据源</vs-th>
			<vs-th >处理时间</vs-th>
			<vs-th >操作</vs-th>
		  </template>
		    <template slot-scope="{data}">
		      <tbody v-if="putlist.length>0">
		        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
		          <vs-td>
		            <p class="product-name font-medium">{{ indextr+1 }}</p>
		          </vs-td>
				  <vs-td>
				    <p class="product-category">{{ tr.deptName }}</p>
				  </vs-td>
				  <vs-td>
				    <p class="product-price">{{ tr.createTime }}</p>
				  </vs-td>
				  <vs-td>
				    <p class="product-price">{{ tr.type==1?'自动提交':tr.type==2?'自动评分':'类型错误' }}</p>
				  </vs-td>
				  <vs-td>
				    <p class="product-price">{{ tr.dataType==1?'处理本月数据':tr.dataType==2?'处理上月数据':'数据源错误' }}</p>
				  </vs-td>
				  <vs-td>
				    <p class="product-price">{{ tr.date }}</p>
				  </vs-td>
				  <vs-td>
				    <vs-button class="mr-4" color="primary" type="filled" @click.stop="edit(tr)"  size="small">编辑</vs-button>
					<vs-button color="danger" type="filled" @click="del(tr.id)"  size="small">删除</vs-button>
				  </vs-td>
		        </vs-tr>
		      </tbody>
		    </template>
		</vs-table>
		<vs-pagination class="mt-4" :total="total" v-model="itemsPerPage"></vs-pagination>
		
		<!-- 弹窗 -->
		<div class="demo-alignment">
		  <el-dialog :title="title" :visible.sync="diaglo" width="50%"  :close-on-click-modal="false">
			<el-form  label-width="120px">
			  <el-form-item label="所属部门:" style="80%" >
			    <el-cascader v-model="deptid" ref="cascaderAddr" @change="handleChange" :options="options" :props='props' style="width:360px"></el-cascader>
			  </el-form-item>
			  <el-form-item label="类型:">
			  		 <el-radio v-model="type" :label="1">自动提交</el-radio>
			  		 <el-radio v-model="type" :label="2">自动评分</el-radio>
					 <el-tooltip class="item" effect="dark" content="提示:过期自动处理未提交的企业文化为已提交" placement="top-start" style="font-size: 18px;height: 20px;vertical-align: text-top;margin-left: 2px;">
					      <i class="el-icon-warning-outline"></i>
					 </el-tooltip>
			  </el-form-item>
			  <el-form-item label="数据源:">
			  		 <el-radio v-model="dataType" :label="1">本月数据</el-radio>
			  		 <el-radio v-model="dataType" :label="2">上月数据</el-radio>
			  		 <el-tooltip class="item" effect="dark" content="提示:处理的数据源是上月企业文化还是本月企业文化" placement="top-start" style="font-size: 18px;height: 20px;vertical-align: text-top;margin-left: 2px;">
			  			 <i class="el-icon-warning-outline"></i>
			  		 </el-tooltip>
			  </el-form-item>
			  <el-form-item label="处理时间:">
			  	 <el-input-number style="margin-right: 43px;" v-model="date"  :min="1" :max="31" label="描述文字"></el-input-number>
				 <el-tooltip class="item" effect="dark" content="提示:处理的时间节点" placement="top-start" style="font-size: 18px;height: 20px;vertical-align: text-top;margin-left: 2px;">
				 		<i class="el-icon-warning-outline"></i>
				 </el-tooltip>
			  </el-form-item>
			  <el-form-item>
			    <el-button type="primary" @click="save">提交</el-button>
			    <el-button @click="diaglo=false">取消</el-button>
			  </el-form-item>
			</el-form>	
		  </el-dialog>
		</div>
	</div>
</template>
<script>
	export default {
	    data() {
	        return {
				putlist: [],
				total:0,
				itemsPerPage:1,
				options:[],     //部门列表
				props:{
					checkStrictly: true,
					value:'id',
					label:'name'
				},
				title:"添加规则",
				diaglo:false,
				id:'',
				deptName:'',
				deptid:[],
				date:15,
				type:1,
				dataType:1,
			}
	    },
		mounted() {
			this.getoptions();
			this.getlist();
		},
		watch: {
		    itemsPerPage:'getlist'
		}, 
		methods:{
			getoptions(){	//获取部门列表
				const that = this;
				this.$api.getmember({}).then(function (response) {
						console.log("组织架构：",response);
						if(response.code==0){
							that.options=that.removeEmptyChildren(response.data);
						}else{
							that.$vs.notify({
								title:"提示",
								color:'warning',
								text:response.message,
								position:'top-center'
							});
						}
				})
			},
			handleChange(value){
				console.log("选择的部门",value);
				this.deptName=this.$refs['cascaderAddr'].getCheckedNodes()[0].label;
			},
			removeEmptyChildren (node) {   //杀生
				var that=this;
				node.forEach(item => {
				if ('children' in item && item.children.length === 0) {
					delete item.children
				} else if ('children' in item && item.children.length) {
					that.removeEmptyChildren(item.children)
				}
				})
				return node;
			},
			
			addrule(){
				console.log("添加");
				this.title="添加规则";
				this.diaglo=true;
				this.deptid=[];
				this.date=15;
				this.type=1;
				this.dataType=1;
			},
			edit(item){  //编辑
				console.log("编辑内容",item);
				this.title="修改规则";
				this.diaglo=true;
				this.id=item.id;
				this.deptName=item.deptName;
				this.deptid=item.deptIds;
				this.date=item.date;
				this.type=item.type;
				this.dataType=item.dataType;
			},
			save(){	
				var that=this;
				if(this.id){  //编辑
					this.$api.edithandletest(
					{
						id:that.id,
						date:that.date,
						deptName:that.deptName,
						deptId:that.deptid[that.deptid.length-1],
						dataType:that.dataType,
						type:that.type
					}).then(function (response) {
						if(response.code==0){
							that.$vs.notify({
								  title:"提示",
								  color:'success',
								  text:response.message,
								  position:'top-center'
							});
							that.diaglo=false;
							that.getlist();
						}else{
							that.$vs.notify({
								  title:"提示",
								  color:'warning',
								  text:response.message,
								  position:'top-center'
							});
						}
					})
				}else{  //添加
					this.$api.savehandletest({
						date:that.date,
						deptName:that.deptName,
						deptId:that.deptid[that.deptid.length-1],
						dataType:that.dataType,
						type:that.type
					}).then(function (response) {
						if(response.code==0){
							that.$vs.notify({
								  title:"提示",
								  color:'success',
								  text:response.message,
								  position:'top-center'
							});
							that.diaglo=false;
							that.getlist();
						}else{
							that.$vs.notify({
								  title:"提示",
								  color:'warning',
								  text:response.message,
								  position:'top-center'
							});
						}
					})
				}
			},
			
			del(id){
				console.log("删除id",id);
				var that=this;
				this.$api.delhandletest({id:id}).then(function (response) {
					if(response.code==0){
						that.$vs.notify({
							  title:"提示",
							  color:'success',
							  text:response.message,
							  position:'top-center'
						});
						that.getlist();
					}else{
						that.$vs.notify({
							  title:"提示",
							  color:'warning',
							  text:response.message,
							  position:'top-center'
						});
					}
				})
			},
			getlist(){    //获取列表
					 const thisIns = this;
					 this.$api.gethandletest({pageNum:thisIns.itemsPerPage,pageSize:10,}).then(function (response) {
					 	console.log("列表数据：",response);
					 	if(response.code==0){
					 		 thisIns.putlist=response.data.data;
					 		 thisIns.total=response.data.pages;
					 	}else{
					 		thisIns.$vs.notify({
					 			  title:"提示",
					 			  color:'warning',
					 			  text:response.message,
					 			  position:'top-center'
					 		});
					 	}
					   }) 
			},
			
			
		},
	}
</script>
<style type="text/css">
	.expandlabel{
		width: 200px;
	}
</style>
